import {useEffect, useMemo} from 'react';

import {sessionApi} from 'api';
import {MessagesModal} from 'components';
import {useApiData, usePrevious} from 'hooks';
import {OnlineSession, SessionActivityName} from 'interfaces';
import {sessionUtils} from 'utils';

type Props= {
    open: boolean;
    session?: OnlineSession;
    activityName?: SessionActivityName;
    onClose: (params?: {ibm?: {sessionHistoryKey: string}}) => void;
}

export const ActivityDataModal: React.FC<Props> = ({open, session, activityName, onClose}) => {
    const prevOpen = usePrevious(open);

    const {send: fetchActivityData, data, loading, error} = useApiData(sessionApi.getActivityData);
    const messages = useMemo(() => sessionUtils.getTextChatActivityMessages(data?.activities?.[0]?.data?.threads), [data]);
    const integrations = useMemo(() => data?.activities?.[0]?.data?.integrations, [data]);

    const userParticipantIds = useMemo(() => sessionUtils.getUserParticipantIdGroups(session), [session]);

    useEffect(() => {
        if (session && open && !prevOpen) {
            fetchActivityData(session.id, activityName);
        }
    }, [open, prevOpen, session, activityName, fetchActivityData]);

    return (
        <MessagesModal
            open={open}
            participants={session?.participants}
            sessionId={session?.id}
            activityName={activityName}
            isLoading={loading}
            isError={!!error}
            userParticipantIds={userParticipantIds}
            hideConversationSummary
            integrations={integrations}
            messages={messages}
            onClose={onClose}
        />
    );
};